import { IAddAccountManagerUser, IAccountManagerSearch, IAccountManagerScheduledJobsSearchParams, IAccountManagerSearchReportParameters } from "../models"
import AxiosInstance from "./AxiosInstance"
const axiosInstance = new AxiosInstance().instance

export function accountManagerPatchSpecificAccount(accountId, account, accountTicks) {
    const settingTicksInterceptor = axiosInstance.interceptors.request.use(config => {
        config.headers["TicksSinceChange"] = accountTicks
        config.headers["proxy"] = accountId
        return config
    })
    axiosInstance.interceptors.response.use(response => {
        // Removing Interceptor on Response
        axiosInstance.interceptors.request.eject(settingTicksInterceptor)
        return response
    })
    return axiosInstance.patch(`/accounts/${accountId}`, account)
}

export function accountManagerCreateAccountHRISSettingsFromAccount(accountId) {
    const settingProxyInterceptor = axiosInstance.interceptors.request.use(config => {
        config.headers["proxy"] = accountId
        return config
    })
    axiosInstance.interceptors.response.use(response => {
        // Removing Interceptor on Response
        axiosInstance.interceptors.request.eject(settingProxyInterceptor)
        return response
    })
	return axiosInstance.get("/accounthrissettings/create_from_account")
}

export function getAccountManagers() {
    return axiosInstance.get(`/account_manager`)
}

export function getAccountManagerById(id: string) {
    return axiosInstance.get(`/account_manager/${id}`)
}

export function getAccountManagerAccounts(accountManagerSearchParams: IAccountManagerSearch) {
    return axiosInstance.post(`/account_manager/accounts`, accountManagerSearchParams)
}

export function getClientAccountsDataDownload(clientReportParams: IAccountManagerSearchReportParameters) {
	return axiosInstance.post(`reporting/account_manager_clients_report`, clientReportParams)
}

export function getAccountManagerScheduledJobs(accountManagerScheduledJobSerachParams: IAccountManagerScheduledJobsSearchParams) {
	return axiosInstance.post(`accounts/scheduled_account_manager_jobs`, accountManagerScheduledJobSerachParams)
}

export function getMarketingFunnelData() {
    return axiosInstance.get("/account_manager/marketing_funnel")
}

export function getAccountManagerUsers() {
	return axiosInstance.post("/account_manager/users")
}

export function addAccountManagerUser(accountManagerUser: IAddAccountManagerUser) {
	return axiosInstance.post("/account_manager/add_user", accountManagerUser)
}

export function updateAccountManagerUser(accountManagerUser: IAddAccountManagerUser, accountManagerUserId: string) {
	return axiosInstance.put(`/account_manager/update_user/${accountManagerUserId}`, accountManagerUser)
}

export function deleteAccountManagerUser(accountManagerUserId: string) {
	return axiosInstance.delete(`/account_manager/delete_user/${accountManagerUserId}`)
}

export function getAccountDetails(accountId: string) {
    const settingProxyInterceptor = axiosInstance.interceptors.request.use(config => {
        config.headers["proxy"] = accountId
        return config
    })
    axiosInstance.interceptors.response.use(response => {
        // Removing Interceptor on Response
        axiosInstance.interceptors.request.eject(settingProxyInterceptor)
        return response
    })
    return axiosInstance.get("/accounts/" + accountId)
}